import React, {useState} from "react";
import {Row, Descriptions, Collapse} from "antd";
import {
    CollapseContainer,
    MapContainer,
    OrderMergeContainer
} from "../../subCompanyDetail/scDetailStyles";
import {Link} from "react-router-dom";
import {SingleMarkerMap} from "../../../_defaultComponents/SingleMarkerMap/SingleMarkerMap";
import {ConditionalTooltip} from "../../../_defaultComponents/ConditionalTooltip/ConditionalTooltip";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import moment from "moment";
import {EditOutlined, ShopOutlined, LoadingOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../../hooks/useStore";
import {ChangeSubcompanyOnboardingStatusInput} from "../../../_defaultComponents/ChangeSubcompanyOnboardingStatusInput/ChangeSubcompanyOnboardingStatusInput";
import {CourierLink} from "../../../_defaultComponents/CourierLink/CourierLink";

export const SubCompanyDetailTab = ({subCompanyId, subCompany, recall = () => {}}) => {
    const {Panel} = Collapse;
    const stores = useStore();
    const {t, i18n} = useTranslation(["subcompanyDetail", "courierTypes"]);

    const [dedicatedCouriersLoading, setDedicatedCouriersLoading] = useState(false);
    const [dedicatedCouriers, setDedicatedCouriers] = useState(undefined);

    const onAssignedCouriersPanelToggle = async activePanels => {
        if (!activePanels || activePanels.length === 0) {
            return;
        }
        if (dedicatedCouriers) {
            return;
        }

        setDedicatedCouriersLoading(true);
        const getDedicatedCourierResponse = await stores.courierStore.getDedicatedCourier({
            companyId: subCompany?.data?.companyId,
            subCompanyId: subCompany?.data?._id
        });

        if (!getDedicatedCourierResponse || !getDedicatedCourierResponse?.couriers) {
            setDedicatedCouriersLoading(false);
            return;
        }

        setDedicatedCouriers(getDedicatedCourierResponse?.couriers);
        setDedicatedCouriersLoading(false);
    };
    return (
        <>
            <Descriptions
                column={2}
                title={
                    <>
                        <Row type="flex" justify="space-between">
                            {subCompany?.data?.name} | 
                            {subCompany?.data?.company?.companyName}
                            <Row
                                type="flex"
                                justify="end"
                                align="middle"
                                style={{rowGap: "8px", columnGap: "8px"}}
                            >
                                {stores.meStore.checkRole("changeSubcompanyOnboardingStatus") &&
                                subCompany?.data ? (
                                    <ChangeSubcompanyOnboardingStatusInput
                                        subCompany={subCompany?.data}
                                        recall={recall}
                                    />
                                ) : (
                                    <></>
                                )}
                                {stores.meStore.checkRole("updateCompany") && (
                                    <ConditionalTooltip
                                        text={t(
                                            "subcompanyDetail.disabledUpdateSubcompanyTooltip",
                                            {
                                                ns: "subcompanyDetail"
                                            }
                                        )}
                                        condition={subCompany.data.disabled}
                                        child={
                                            <Link
                                                to={{
                                                    pathname:
                                                        "/companies/update-sub-company/" +
                                                        subCompany.data._id
                                                }}
                                            >
                                                <CustomButton
                                                    type="primary"
                                                    disabled={subCompany.data.disabled}
                                                    icon={<EditOutlined />}
                                                    style={{marginTop: "0px"}}
                                                />
                                            </Link>
                                        }
                                    />
                                )}
                            </Row>
                        </Row>
                    </>
                }
                bordered
            >
                <Descriptions.Item span={1} label="Tabela Adı">
                    {subCompany.data.signName || "-"}
                </Descriptions.Item>
                <Descriptions.Item label={t("fields.testUser", {ns: "common"})}>
                    {subCompany.data.isTestUser
                        ? t("other.yes", {ns: "common"})
                        : t("other.no", {ns: "common"})}
                </Descriptions.Item>
                <Descriptions.Item span={1} label="Firma Kategorisi">
                    {subCompany.data.category || "-"}
                </Descriptions.Item>
                <Descriptions.Item span={1} label="Tahsilat Miktarı">
                    {subCompany.data.collectionAmount
                        ? subCompany.data.collectionAmount + " TL"
                        : "-"}
                </Descriptions.Item>
                <Descriptions.Item span={1} label="Maksimum Mesafe">
                    {subCompany.data.maxAcceptableDistance
                        ? subCompany.data.maxAcceptableDistance + " km"
                        : "- km"}
                </Descriptions.Item>
                <Descriptions.Item span={1} label={t("fields.companyActivity", {ns: "common"})}>
                    {subCompany.data.disabled
                        ? t("other.inactive", {ns: "common"})
                        : t("other.active", {ns: "common"})}
                </Descriptions.Item>
                <Descriptions.Item span={1} label="Alt Firma Onay Durumu">
                    {subCompany?.data?.onboardingStatus &&
                    subCompany?.data?.onboardingStatus !== "undefined"
                        ? t(
                              `fields.subCompanyOnboardingOptions.${subCompany?.data?.onboardingStatus}`,
                              {
                                  ns: "common"
                              }
                          )
                        : "-"}
                </Descriptions.Item>
                <Descriptions.Item span={1} label={t("fields.subCompanyCode", {ns: "common"})}>
                    {subCompany.data.subCompanyCode &&
                        `${subCompany.data.subCompanyCode.companyCode}${(
                            "00" + subCompany.data.subCompanyCode.cityCode
                        ).slice(-2)}${("0000" + subCompany.data.subCompanyCode.code).slice(-4)}`}
                </Descriptions.Item>
                <Descriptions.Item span={1} label={t("fields.createdBy", {ns: "common"})}>
                    {subCompany.data.createdBy || t("other.unspecified", {ns: "common"})}
                </Descriptions.Item>
                <Descriptions.Item span={2} label={t("fields.createdDate", {ns: "common"})}>
                    {subCompany.data.createdAt
                        ? moment(subCompany.data.createdAt)
                              .locale(i18n.resolvedLanguage || "tr")
                              .format("DD-MM-YYYY HH:mm:ss")
                        : t("other.unspecified", {ns: "common"})}
                </Descriptions.Item>
                <Descriptions.Item span={1} label={t("fields.updatedBy", {ns: "common"})}>
                    {subCompany.data.updatedBy || t("other.unspecified", {ns: "common"})}
                </Descriptions.Item>
                <Descriptions.Item
                    span={1}
                    label={t("subcompanyDetail.fields.updatedAt", {
                        ns: "subcompanyDetail"
                    })}
                >
                    {subCompany.data.updatedAt
                        ? moment(subCompany.data.updatedAt)
                              .locale(i18n.resolvedLanguage || "tr")
                              .format("DD-MM-YYYY HH:mm:ss")
                        : t("other.unspecified", {ns: "common"})}
                </Descriptions.Item>
                <Descriptions.Item span={1} label="Manuel Atama">
                    {subCompany.data.isAllocateClosed ? "Açık" : "Kapalı"}
                </Descriptions.Item>
                <Descriptions.Item span={1} label={t("fields.city", {ns: "common"})}>
                    {subCompany.data.city}
                </Descriptions.Item>
                <Descriptions.Item span={1} label={t("fields.county", {ns: "common"})}>
                    {subCompany.data.city && subCompany.data.county}
                </Descriptions.Item>
                <Descriptions.Item span={1} label={t("fields.region", {ns: "common"})}>
                    {subCompany.data.region?.name || t("filters.all", {ns: "common"})}
                </Descriptions.Item>
                <Descriptions.Item span={1} label={t("fields.regionGroup", {ns: "common"})}>
                    {subCompany.data.regionGroup?.name ||
                        t("subcompanyDetail.unassigned", {ns: "subcompanyDetail"})}
                </Descriptions.Item>
                <Descriptions.Item span={1} label={t("fields.upperGroup", {ns: "common"})}>
                    {subCompany.data.upperRegionGroup ||
                        t("subcompanyDetail.unassigned", {ns: "subcompanyDetail"})}
                </Descriptions.Item>
                <Descriptions.Item span={2} label={t("fields.address", {ns: "common"})}>
                    {subCompany.data.address}
                </Descriptions.Item>
                <Descriptions.Item span={1} label={t("fields.authorizedPerson", {ns: "common"})}>
                    {subCompany.data.authorizedPerson}
                </Descriptions.Item>
                <Descriptions.Item span={1} label={t("fields.authorizedID", {ns: "common"})}>
                    {subCompany.data.authorizedID}
                </Descriptions.Item>
                <Descriptions.Item span={1} label={t("fields.authorizedPhone", {ns: "common"})}>
                    {subCompany.data.authorizedPhone}
                </Descriptions.Item>
                <Descriptions.Item span={1} label={t("fields.authorizedEmail", {ns: "common"})}>
                    {subCompany.data.authorizedEmail}
                </Descriptions.Item>
                <Descriptions.Item span={2} label={t("fields.uniqueKey", {ns: "common"})}>
                    {subCompany.data.uniqueKey}
                </Descriptions.Item>
                <Descriptions.Item
                    span={2}
                    label={t("fields.allowedOrderProviders", {ns: "common"})}
                >
                    {subCompany.data.allowedOrderProviders?.join()}
                </Descriptions.Item>
                <Descriptions.Item span={2} label={"Kasa Yazılım Sistemi"}>
                    {subCompany?.data?.cashRegisterMethod
                        ? subCompany.data.cashRegisterMethod
                        : "-"}
                </Descriptions.Item>
                <Descriptions.Item span={2} label={"External ID"}>
                    {subCompany?.data?.externalId ? subCompany.data.externalId : "-"}
                </Descriptions.Item>
            </Descriptions>
            {stores.meStore.role == "admin" &&
                subCompany.data?.options?.merge?.map((mergeOptions, index) =>
                    mergeOptions.isActive ? (
                        <OrderMergeContainer
                            column={3}
                            size="small"
                            bordered
                            key={"OrderMergeContainer" + index}
                        >
                            <Descriptions.Item
                                span={3}
                                label={t("fields.courierType", {ns: "common"})}
                            >
                                {mergeOptions?.courierType === "motorCourier"
                                    ? t("longForm.motorCourier", {ns: "courierTypes"})
                                    : t("longForm.carCourier", {ns: "courierTypes"})}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.mergeOptions.orderMerge.label", {
                                    ns: "common"
                                })}
                            >
                                {mergeOptions?.isActive
                                    ? t("other.active", {ns: "common"})
                                    : t("other.passive", {ns: "common"})}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.mergeOptions.clickToDoorTime.label", {
                                    ns: "common"
                                })}
                            >
                                {mergeOptions?.clickToDoorTime +
                                    " " +
                                    t("units.minute.long", {ns: "common"})}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.mergeOptions.prepTime.label", {
                                    ns: "common"
                                })}
                            >
                                {mergeOptions?.prepTime +
                                    " " +
                                    t("units.minute.long", {ns: "common"})}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.mergeOptions.prepTimeBufferPercent.label", {
                                    ns: "common"
                                })}
                            >
                                {"%" + mergeOptions?.prepTimeBufferPercent}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.mergeOptions.handOverTime.label", {
                                    ns: "common"
                                })}
                            >
                                {mergeOptions?.handOverTime +
                                    " " +
                                    t("units.minute.long", {ns: "common"})}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.mergeOptions.mergeMaxOrder.label", {
                                    ns: "common"
                                })}
                            >
                                {mergeOptions?.maxOrder +
                                    " " +
                                    t("units.piece.long", {ns: "common"})}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.mergeOptions.mergeWithOtherVehicleTypes.label", {
                                    ns: "common"
                                })}
                            >
                                {mergeOptions?.mergeWithOtherTypes
                                    ? t("other.active", {ns: "common"})
                                    : t("other.passive", {ns: "common"})}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.mergeOptions.mergeWithOtherCompanies.label", {
                                    ns: "common"
                                })}
                            >
                                {mergeOptions?.mergeWithOtherCompanies
                                    ? t("other.active", {ns: "common"})
                                    : t("other.passive", {ns: "common"})}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.mergeOptions.maxPickup.label", {
                                    ns: "common"
                                })}
                            >
                                {mergeOptions?.maxPickup + " adet"}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.mergeOptions.regionRestriction.label", {
                                    ns: "common"
                                })}
                            >
                                {mergeOptions?.regionRestriction
                                    ? t("other.active", {ns: "common"})
                                    : t("other.passive", {ns: "common"})}
                            </Descriptions.Item>
                        </OrderMergeContainer>
                    ) : null
                )}
            {stores.meStore.role == "admin" && subCompany.data?.options?.queue?.isActive ? (
                <OrderMergeContainer column={3} size="small" bordered>
                    <Descriptions.Item
                        label={t("fields.queueOptions.orderQueue.label", {
                            ns: "common"
                        })}
                    >
                        {subCompany.data?.options?.queue?.isActive
                            ? t("other.active", {ns: "common"})
                            : t("other.passive", {ns: "common"})}
                    </Descriptions.Item>
                    <Descriptions.Item
                        label={t("fields.queueOptions.maxOrderCount.label", {
                            ns: "common"
                        })}
                    >
                        {subCompany.data?.options?.queue?.maxCount}
                    </Descriptions.Item>
                    <Descriptions.Item
                        label={t("fields.queueOptions.maxWaitingTime.label", {
                            ns: "common"
                        })}
                    >
                        {subCompany.data?.options?.queue?.maxWaitingTime +
                            " " +
                            t("units.minute.long", {ns: "common"})}
                    </Descriptions.Item>
                    <Descriptions.Item
                        label={t("fields.queueOptions.thresholdCount.label", {
                            ns: "common"
                        })}
                    >
                        {"%" + subCompany.data?.options?.queue?.thresholdCount}
                    </Descriptions.Item>
                    <Descriptions.Item
                        label={t("fields.queueOptions.thresholdTime.label", {
                            ns: "common"
                        })}
                    >
                        {subCompany.data?.options?.queue?.thresholdTime +
                            " " +
                            t("units.minute.long", {ns: "common"})}
                    </Descriptions.Item>
                </OrderMergeContainer>
            ) : null}

            {stores.meStore.role == "admin" ? (
                <OrderMergeContainer column={3} size="small" bordered>
                    <Descriptions.Item
                        label={t("fields.forceCourierNotificationDistance", {
                            ns: "common"
                        })}
                    >
                        {subCompany.data?.forceCourierNotificationDistance
                            ? subCompany.data?.forceCourierNotificationDistance +
                              " " +
                              t("units.meter.long", {ns: "common"})
                            : "-"}
                    </Descriptions.Item>
                </OrderMergeContainer>
            ) : null}

            <CollapseContainer>
                <Collapse onChange={e => onAssignedCouriersPanelToggle(e)}>
                    <Panel
                        header={t("subcompanyDetail.assignedCouriers", {
                            ns: "subcompanyDetail"
                        })}
                    >
                        {dedicatedCouriersLoading ? (
                            <LoadingOutlined />
                        ) : dedicatedCouriers?.length > 0 ? (
                            dedicatedCouriers.map(courier => (
                                <div key={courier.id}>
                                    <CourierLink target="_blank" to={`/couriers/${courier.id}`}>
                                        {courier.fullname}
                                    </CourierLink>
                                </div>
                            ))
                        ) : (
                            t("subcompanyDetail.unassignedCourier", {
                                ns: "subcompanyDetail"
                            })
                        )}
                    </Panel>
                </Collapse>
            </CollapseContainer>

            <MapContainer>
                <SingleMarkerMap
                    center={{
                        lat: subCompany?.data?.location?.latitude,
                        lng: subCompany?.data?.location?.longitude
                    }}
                    icon={<ShopOutlined />}
                />
            </MapContainer>
        </>
    );
};
